export default {
  confLabels: {
    'PrevPage': '&#x2190;Prev',
    'NextPage': 'Next&#x2192;',

    '***Headings / Menu': '***',
    'Title': 'LeakCentral',
    'RequiredFields': 'Required Fields missing',
    'DeviceList': 'Device List',
    'DeviceView': 'Device View',
    'LowLeakList': 'Low Leak List',
    'ReportsHeading': 'Reports',
    'uncompleteInstalls': 'Incomplete Installs',
    'CustomerSupport': 'Customer Support',
    'LandingPageHeading': 'Dashboard',
    'SimlatorPageHeading': 'Simulator',
    'updateTenant': 'Update Tenant',
    'searchHeading': 'Search',
    'updateParametersHeading': 'Update Parameters',
    'matlabParametersHeading': 'Matlab Parameters Dictionary',
    'deviceMatlabParametersHeading': 'Device Matlab Parameters',
    'createParamUpdHeading': 'Create Parameter Update',
    'leaklistHeading': 'Leak List',
    'eventlistHeading': 'Event List',
    'messagelistHeading': 'Message List',
    'eventTypeHeading': 'Type',
    'createUser': 'Create User',
    'createTenant': 'Create Tenant',

    '***Event Types***': '***',
    'LeakTrue': 'Leak',
    'LeakFalse': 'No Leak',
    'InitialMonitoring': 'Initial Monitoring',
    'Monitoring': 'Suspected',
    'DeviceStuck': 'Device Stuck',
    'AgentLeakRequest': 'Agent Triggered Leak',
    'HardwareProblem': 'Hardware Fault',
    'LowBattery': 'Low Battery',
    'HotPipe': 'On Hot Pipe',
    'OffLineDevice': 'Lost Signal',
    'NoSignal': 'No Signal',
    'UserLeakRequestNoSignal': 'User Triggered Leak',
    'LowSignalDevice': 'Low Signal',
    'HighFlow': 'High Usage',
    'NoHighFlow': 'No High Usage',
    'All': 'All',

    '***Login Page': '***',
    'LogInHeading': 'Welcome to LeakCentral',
    'LogInSubHeading': 'Please log in',
    'ResetPasswordHeading': 'Please reset password',
    'PopulateEmailHeading': 'Forgotten your password?',

    '***Password reset request': '***',
    'PopulateEmailDesciption': 'Enter your email and we\'ll send you a link to reset it',

    '***Provide New Password': '***',
    'InputEmail': 'Email address',
    'Password': 'Password',
    'PasswordDetails': 'Password needs to be at least 8 characters long. It has to have at least 1 upper case character, 1 lower case character, 1 number and 1 special character @#%!$',
    'RepeatPassword': 'Repeat password',

    '***Login Messages': '***',
    'EmailCouldNotBeSent': 'Status changed but unable to send email',
    'InvalidCredentials': 'Oops! The details you\'ve entered aren\'t valid. Please try again.',
    'LoggedOut': 'You have been successfully logged out. Please log in again.',
    'SessionExpired': 'Sorry, you\'ve been logged out of LeakCentral. Please log in again to continue.',
    'ResetPwdEmailSent': 'We have sent an email to <i><email></i>. Please use the link in the email to reset your password',
    'SuccessfullyChangedPwd': 'Password successfully changed',
    'invalidOTP': 'Code not recognised, please try again',
    'invalidInput': 'Username or Password not correctly Formatted',
    'loginNotAuthorised': 'No user access',

    '***Column Headings': '***',
    'DeviceID': 'Device ID',
    'EventID': 'Event ID',
    'LowLeakId': 'Leak ID',
    'XaTenant_ID': 'Tenant ID',
    'deviceName': 'Device Name',
    'batteryVoltage': 'Battery Level',
    'platformEvaluatedLeakBitSet': 'Leak Detected',
    'messageTimestamp': 'Time',
    'Username': 'Username',
    'pipeTempsIsCrossed': 'Pipe Temp. Crossed',
    'pipeCrossThreshIsExceeded': 'Pipe Temp. Exceeded',
    'tAir1': 'Temp Air 1',
    'tAir2': 'Temp Air 2',
    'tAir3': 'Temp Air 3',
    'tPipe1': 'Temp Pipe 1',
    'tPipe2': 'Temp Pipe 2',
    'tPipe3': 'Temp Pipe 2',
    'tenantHeading': 'Tenant',
    'installTimestampHeading': 'Install timestamp',
    'diagnosisGroupHeading': 'Diagnostic Group',
    'needHelpHeading': 'Need Help',
    'repairCompleteHeading': 'Repair Complete',
    'postCodeHeading': 'Postcode',
    'leakActiveDate': 'Leak active date',
    'leakClosedDate': 'Leak closed date',
    'daysActive': 'Number of days active',
    'isVIP': 'isVIP',
    'eventOpenDate': 'Date opened',
    'eventCloseDate': 'Date closed',
    'crmBusinessCodeHeading': 'CRM Action',
    'crmBusinessTimestampHeading': 'CRM Action Date',
    'emailCode': 'Email',
    'commType': 'Type',
    'languageDesc': 'Language',
    'tenantName': 'Tenant',
    'subject': 'Subject',
    'ID': 'ID',

    '***Search Page': '***',
    'noSearchResults': 'No matches found',
    'incorrectDateFormat': 'Incorrect date format:  YYYY-MM-DD',

    '***Device View': '***',
    'RemoveDeviceText': '<p>Are you sure you want to remove this device from the user? This action cannot be undone and will mean the user can no longer see anything to do with their device.</p>',
    'RemoveDeviceFail': '<p>Error:  The device was not removed from the account and no changes were made. Please try again.</p>',
    'RemoveDeviceSuccess': '<p>Success:  The device has been removed from the account and can now be reassigned to another account if needed. Click \'OK\' below to be redirected to the device list</p>',
    'ConfirmRepairText': '<p>Has this leak been confirmed repaired? This change cannot be reversed</p>',
    'ConfirmRepairFail': '<p>Error:  It was not possible to mark this leak as repaired. Please try again.</p>',
    'ConfirmRepairSuccess': '<p>Success:  This leak has been marked as repaired.</p>',

    '***Update Parameters Page': '***',
    'updParamPageDesc': 'This page is provided so that you can update the parameters of a single device. You can stack up as many as you like.<br><br><i>Please remember</i> - For SigFox devices they are only able to receive 4 parameters per day and these parameters will only be sent when the device sends an acknowledged message.',
    'successUpdateParam': 'LeakBot ID <leakbotId> has parameter update queued with following details -<br>Logging - <logging><br>Parameter - <parameterSel><br>Parameter Value - <parameterValue><br><br>',
    'updParamOutOfRange': 'Parameter out of range',
    'updParamDoesNotExist': 'Device does not exist',

    '---Column Headings - Device List Journal': '---',
    '#': '#',
    'id': 'id',
    // 'DeviceID': 'LeakBot ID',
    'SigFoxID': 'SigFox ID',
    'Name': 'Name',
    'Surname': 'Surname',
    'ConsecutiveLeaks': 'Consecutive Leaks',
    'Day3Count': '3 Day Count',
    'Day3Sum': '3 Day Sum',
    'Day5Count': '5 Day Count',
    'Day5Sum': '5 Day Sum',
    'Day10Count': '10DayCount',
    'Day10Sum': '10 Day Sum',
    'LastLeakMessage': 'Last Leak Message',
    'LastStatusMessage': 'Last Status Message',
    'CustomerStatus': 'Customer Status',

    '---Column Headings - User Report': '---',
    'device_id': 'Device ID',
    'battery_level': 'Battery Level',
    'customer_installed_date': 'Customer Install Date',
    'customer_status': 'Customer Status',
    'customer_status_change_date': 'Customer Status Change Date',
    'customer_surname': 'Surname',
    'days_since_customer_status_change_date': 'Days Since Status Change',
    'fitting_error': 'Fitting Error',
    'hw_fault': 'Hardware Fault',
    'in_logging': 'In Logging',
    'last_leak_message': 'Last Leak Message',
    'last_status_message_date': 'Last Status Message Date',
    'leak_status': 'Leak Status',
    'leak_status_change_date': 'Leak Status Change Date',
    'leakbot_id': 'LeakBot ID',
    'logging_end_date': 'Logging End Date',
    'logging_start_date': 'Loggin Start Date',
    'sigfox_id': 'SigFox ID',
    'signal_success_rate': 'Signal Success Rate',
    'tenant': 'Tenant',

    '---Column Headings - Low Signal Report': '---',
    'event_created_date': 'Event Created Date',
    'event_closed_date': 'Event Closed Date',
    'requested_antenna': 'Requested Antenna',
    'requested_antenna_date': 'Larger Antenna Requested Date '
  }
}
